import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import exportarMetricasExcel from "../utils/performance/exportarMetricasExcel";
import { obtenerMetricas, limpiarMetricas, estaPerfDebugActivo } from "../utils/performance/perfTracker";
import { ambiente } from "../config/constantes";

const PerfMetricsButton = ({ vista = "Inicio" }) => {
  const [cantidad, setCantidad] = useState(0);
  const [cargandoLlamadas, setCargandoLlamadas] = useState(true);
  const [exportando, setExportando] = useState(false);
  const [debugActivo, setDebugActivo] = useState(estaPerfDebugActivo());

  useEffect(() => {
    const actualizar = () => {
      const metricas = obtenerMetricas().filter((m) => m.vista === vista);
      setCantidad(metricas.length);
      // La medición "Total" se guarda al final de getData(), así que mientras no exista
      // significa que la vista todavía sigue haciendo llamadas.
      setCargandoLlamadas(!metricas.some((m) => m.categoria === "Total"));
      setDebugActivo(estaPerfDebugActivo());
    };

    actualizar();
    const intervalo = setInterval(actualizar, 800);
    return () => clearInterval(intervalo);
  }, [vista]);

  if (!debugActivo) return null;

  const handleExportar = async () => {
    setExportando(true);
    try {
      await exportarMetricasExcel(vista);
      Swal.fire({
        icon: "success",
        title: "Excel generado",
        text: "Se descargaron las métricas de rendimiento de la vista Inicio.",
        timer: 2500,
        showConfirmButton: false,
      });
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: "No se pudo exportar",
        text: error.message,
      });
    } finally {
      setExportando(false);
    }
  };

  const handleLimpiar = () => {
    limpiarMetricas();
    setCantidad(0);
    setCargandoLlamadas(true);
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 1050,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: 6,
      }}
    >
      <div className="d-flex gap-2">
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary shadow-sm"
          onClick={handleLimpiar}
          title="Borrar métricas capturadas en esta sesión"
        >
          <i className="bi bi-trash" /> Limpiar
        </button>
        <button
          type="button"
          className="btn btn-sm btn-danger shadow-sm"
          onClick={handleExportar}
          disabled={exportando || cargandoLlamadas || cantidad === 0}
          title={
            cargandoLlamadas
              ? "Todavía se están registrando las llamadas de la vista"
              : "Exportar tiempos de carga (backend/frontend) a Excel"
          }
        >
          {exportando ? (
            "Generando..."
          ) : cargandoLlamadas ? (
            <>
              <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
              Cargando llamadas ({cantidad})...
            </>
          ) : (
            `Exportar métricas (${cantidad})`
          )}
        </button>
      </div>
      <small className="text-muted bg-white px-2 rounded shadow-sm">
        QA · ambiente: {ambiente}
      </small>
    </div>
  );
};

export default PerfMetricsButton;
